module.exports = __webpack_public_path__ + "static/media/person-with-arrow.59015270.svg";